// extracted by mini-css-extract-plugin
export default {"root":"_2Gl7-","heading-and-subheading-block":"_2-OaC","headingAndSubheadingBlock":"_2-OaC","subheading":"_2wEhC"};